import { Helmet } from "react-helmet-async";
import HomeNav from './HomeNav';
import HomeHero from './HomeHero';
// import HomeLogoStrip from './HomeLogoStrip'; // hidden until brand logos are finalized
import FeatureCards from './FeatureCards';
import HomeNumbers from './HomeNumbers';
import HomeOneBrain from './HomeOneBrain';
import HomeChannels from './HomeChannels';
import HomeUserManual from './HomeUserManual';
import HomeSync from './HomeSync';
import HomeFeatures from './HomeFeatures';
import HomeEconomics from './HomeEconomics';
import HomeInsights from './HomeInsights';
import HomeIndustries from './HomeIndustries';
import HomeGenieCTA from './HomeGenieCTA';
import HomeCTA from './HomeCTA';
import HomeFooter from './HomeFooter';
import GenieEmbed from '@/components/widget/GenieEmbed';
import { getCanonicalUrl } from "@/config/site";
import { createOrganizationSchema, createWebSiteSchema } from "@/config/seo";

export default function HomePage() {
  const title = "Help Genie | Support that runs itself";
  const description =
    "One genie, trained on what your business knows, answering customers across voice, chat, phone, QR, website, mobile, email and outbound, 24/7. Live in an hour, at around ten percent of the cost of a support team.";
  const organizationSchema = createOrganizationSchema();
  const websiteSchema = createWebSiteSchema();

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={getCanonicalUrl("/")} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={getCanonicalUrl("/")} />
        <meta property="og:image" content={getCanonicalUrl("/helpgenie_logo.png")} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={getCanonicalUrl("/helpgenie_logo.png")} />
        <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      </Helmet>

      <div className="min-h-screen w-full flex flex-col bg-[#F9FAFC]">
        <HomeNav />
        <main className="flex-1 flex flex-col items-center justify-center w-full">
          <HomeHero />
          {/* Logo strip hidden until brand logos are finalized — re-enable when ready */}
          {/* <HomeLogoStrip /> */}
          <FeatureCards />
          <HomeOneBrain />
          <HomeNumbers />
          <HomeChannels />
          <HomeUserManual />
          <HomeSync />
          <HomeFeatures />
          <HomeEconomics />
          <HomeInsights />
          <HomeIndustries />
          <HomeGenieCTA />
          <HomeCTA />
        </main>
        <HomeFooter />
        <GenieEmbed position="bottom-right" />
      </div>
    </>
  );
}
